import { ObjectMapper } from "json-object-mapper";
import { IModel } from "../IModel";
import { Model } from "../model";
import { ModuleActionModel } from "./moduleAction.model";

export class AvailableModuleModel
  extends Model
  implements IModel<AvailableModuleModel> {
  name: string = "";
  title: string = "";
  type: string = "";
  url: string = "";
  description: string = "";
  actions: ModuleActionModel[] = [];

  static create(input: any): AvailableModuleModel {
    return ObjectMapper.deserialize<AvailableModuleModel>(AvailableModuleModel, input);
  }

  public toJSON(): string {
    return ObjectMapper.serialize(this) as string;
  }
}
